module.exports = __webpack_public_path__ + "c44c53d4ce24571a3aef977fa7a02392.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/painted-nails-black-s.png
// module id = 2515
// module chunks = 0